"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _colors = require("../../style/colors");
var _excluded = ["children", "classes", "className", "colorScheme", "disabled", "displayErrors", "hasError", "hasValidation", "inputClassName", "invertScheme", "readOnly", "setDisplayErrorsState", "setLoadingState", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      background: theme.colors.blueGrey,
      borderRadius: theme.variables.borderRadius,
      padding: '1.25rem 1rem',
      minHeight: '4rem'
    },
    colorScheme: theme.mixins.colorScheme,
    invertScheme: theme.mixins.invertScheme,
    paneContents: _objectSpread(_objectSpread({}, theme.typography.baseText), {}, {
      color: theme.colors.black
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  children: Node,
  colorScheme?: string,
  invertScheme?: boolean
};*/
var Pane = function Pane(_ref /*:: */) {
  var children = _ref /*:: */.children,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    colorScheme = _ref /*:: */.colorScheme,
    disabled = _ref /*:: */.disabled,
    displayErrors = _ref /*:: */.displayErrors,
    hasError = _ref /*:: */.hasError,
    hasValidation = _ref /*:: */.hasValidation,
    inputClassName = _ref /*:: */.inputClassName,
    invertScheme = _ref /*:: */.invertScheme,
    readOnly = _ref /*:: */.readOnly,
    setDisplayErrorsState = _ref /*:: */.setDisplayErrorsState,
    setLoadingState = _ref /*:: */.setLoadingState,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, invertScheme ? classes.invertScheme : classes.colorScheme, true), className),
    "data-color": colorScheme || undefined
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.paneContents
  }, children));
};
Pane.defaultProps = {
  colorScheme: _colors.BLUE_GREY
};
Pane.displayName = 'Pane';
var _default = exports.default = (0, _injectSheet.default)(Style)(Pane);
//# sourceMappingURL=Pane.js.map